import { IEnsaioAnalise } from "@/interfaces/IEnsaioAnalise";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface EnsaioAnaliseState {
  items: IEnsaioAnalise[];
  synced: boolean;
}

const initialState: EnsaioAnaliseState = {
  items: [],
  synced: false,
};

const ensaioAnaliseSlice = createSlice({
  name: "ENSAIO_ANALISE",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: IEnsaioAnalise[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default ensaioAnaliseSlice.reducer;

export const getEnsaiosAnaliseSynced = (state: RootState) =>
  state.ensaioAnalise.items;
